var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1367 14.5C25.2783 14.5 26.5833 13.2917 25.4233 9.32835C24.6379 6.65793 22.3421 4.3621 19.6717 3.57668C15.7083 2.41668 14.5 3.72168 14.5 6.86335V10.3433C14.5 13.2917 15.7083 14.5 18.125 14.5H22.1367Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 17.7623C23.043 23.3569 17.678 27.4169 11.5759 26.426C6.99631 25.689 3.31089 22.0035 2.56172 17.424C1.58297 11.346 5.61881 5.98105 11.1892 4.84521",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.aa86e1a1142274dddc379563b4ad89ea.svg";
export { ForwardRef as ReactComponent };